module.exports = __webpack_public_path__ + "static/media/ublock.0e437297.jpg";


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/images/ublock.jpg
// module id = 2776
// module chunks = 118